(() => {
  const DELAY = 2000;
  const SELECTOR = '[data-js-product-media-slider]';
  const timers = new WeakMap();

  const schedule = (el, delay = DELAY) => {
    const previous = timers.get(el);
    if (previous) window.clearTimeout(previous);
    timers.set(el, window.setTimeout(() => advance(el), delay));
  };

  const advance = (el) => {
    if (!el || !el.isConnected) return;

    const slides = el.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide');
    if (slides.length < 2) {
      schedule(el, 1000);
      return;
    }

    if (document.hidden) {
      schedule(el);
      return;
    }

    const swiper = el.swiper;

    if (swiper && !swiper.destroyed && swiper.slides && swiper.slides.length > 1) {
      const nextIndex = swiper.activeIndex >= swiper.slides.length - 1 ? 0 : swiper.activeIndex + 1;
      swiper.slideTo(nextIndex, 450);
      schedule(el);
      return;
    }

    // Fallback if the Swiper instance isn't exposed on the element.
    const nextButton = el.querySelector('.swiper-button-next');
    const firstBullet = el.querySelector('.swiper-pagination-bullet');

    if (nextButton && !nextButton.disabled && !nextButton.classList.contains('swiper-button-disabled')) {
      nextButton.click();
    } else if (firstBullet) {
      firstBullet.click();
    }

    schedule(el);
  };

  const initSlider = (el) => {
    if (!el || timers.has(el)) return;

    ['pointerdown', 'touchstart', 'mousedown'].forEach((eventName) => {
      el.addEventListener(eventName, () => schedule(el), { passive: true });
    });

    schedule(el);
  };

  const init = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
  });
})();
